import React from "react";
import { Flag, Building, CheckCircle2, AlertCircle } from "lucide-react";

export default function DeductibilityStatusPill({
  deductiblePct,
  isCapitalImprovement,
  needsCpaReview,
  cpaResolved,
  className = "",
}) {
  // If flagged for CPA review and not yet resolved
  if (needsCpaReview && !cpaResolved) {
    return (
      <span
        title="Flagged for CPA tax review"
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-300 border border-amber-300 dark:border-amber-800/60 shadow-xs shrink-0 whitespace-nowrap w-fit ${className}`}
      >
        <Flag className="w-3 h-3 text-amber-600 fill-amber-600 shrink-0" />
        <span>CPA<span className="hidden min-[380px]:inline"> Review</span></span>
      </span>
    );
  }

  // If capital improvement
  if (isCapitalImprovement) {
    return (
      <span
        title="Capital improvement depreciated over 27.5 yrs (Form 4562)"
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-indigo-100 dark:bg-indigo-950/60 text-indigo-800 dark:text-indigo-300 border border-indigo-300 dark:border-indigo-800/60 shrink-0 whitespace-nowrap w-fit ${className}`}
      >
        <Building className="w-3 h-3 shrink-0" />
        <span>Cap<span className="hidden min-[380px]:inline">italized</span></span>
      </span>
    );
  }

  const pct = deductiblePct !== null && deductiblePct !== undefined ? Number(deductiblePct) : 100;

  if (pct >= 99.9) {
    return (
      <span
        title="100% Tax Deductible on Schedule E"
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-100 dark:bg-emerald-950/60 text-emerald-800 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800/60 shrink-0 whitespace-nowrap w-fit ${className}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-600 dark:bg-emerald-400 shrink-0" />
        <span>100%</span>
      </span>
    );
  }

  if (pct > 0) {
    return (
      <span
        title={`${pct}% Partially Deductible`}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border border-amber-300 dark:border-amber-800/50 shrink-0 whitespace-nowrap w-fit ${className}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 shrink-0" />
        <span>{pct.toFixed(0)}%</span>
      </span>
    );
  }

  return (
    <span
      title="0% Deductible — Excluded from Schedule E"
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border border-slate-300 dark:border-slate-700 shrink-0 whitespace-nowrap w-fit ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" />
      <span>0%</span>
    </span>
  );
}
